var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader',{attrs:{"title":"지점 예약 내역","is-history":""}}),_c('AppContent',[_c('ReservationList')],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }